import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import Router from "./Router";
import { AppProvider } from "./store/AppContext";
import { WordsProvider } from "./store/WordsContext";

// Register service worker for PWA / offline support
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch(() => {});
  });
}

const rootEl = document.getElementById("root");
const app = (
  <BrowserRouter>
    <AppProvider>
      <WordsProvider>
        <Router />
      </WordsProvider>
    </AppProvider>
  </BrowserRouter>
);

// react-snap pre-renders to static HTML; use hydrateRoot when it's available,
// createRoot for normal dev / first-load.
if (rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootEl, app);
} else {
  ReactDOM.createRoot(rootEl).render(app);
}
